"use client";
import { useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import { ChevronDown } from "lucide-react";

const CustomSelect = ({ label, options, value, onChange }) => {
	const [open, setOpen] = useState(false);
	const selected = options.find((opt) => opt.id === value);

	return (
		<div className="zn:w-full zn:text-xs zn:relative zn:mb-3">
			{label && (
				<div className="zn:text-xs zn:!mb-1 zn:block text-gray-700">
					{label}
				</div>
			)}

			{/* Trigger Button */}
			<button
				onClick={() => setOpen((prev) => !prev)}
				className="zn:w-full zn:h-8 zn:px-2 zn:flex zn:items-center zn:justify-between zn:border zn:border-gray-300 zn:rounded-md zn:!bg-white zn:text-xs focus:zn:outline-none focus:zn:ring-2 focus:zn:ring-blue-500"
			>
				<span>{selected?.name || "Select model"}</span>
				<motion.div
					animate={{ rotate: open ? 180 : 0 }}
					transition={{ duration: 0.2 }}
				>
					<ChevronDown className="zn:w-4 zn:h-4 text-gray-500" />
				</motion.div>
			</button>

			{/* Dropdown Menu */}
			<AnimatePresence>
				{open && (
					<motion.ul
						initial={{ opacity: 0, y: -5 }}
						animate={{ opacity: 1, y: 0 }}
						exit={{ opacity: 0, y: -5 }}
						transition={{ duration: 0.2 }}
						className="zn:absolute zn:mt-1 zn:!space-y-2 zn:!p-4 zn:w-full zn:!bg-white zn:shadow-lg zn:border zn:!border-gray-200 zn:rounded-md zn:z-50 zn:overflow-hidden"
					>
						{options.map((opt) => (
							<li
								key={opt.id}
								onClick={() => {
									onChange(opt.id);
									setOpen(false);
								}}
								className={`zn:px-3 zn:py-2 zn:cursor-pointer hover:zn:!bg-primary ${
									opt.id === value ? "zn:bg-primary/20 zn:font-medium" : ""
								}`}
							>
								{opt.name}
							</li>
						))}
					</motion.ul>
				)}
			</AnimatePresence>
		</div>
	);
};

export default CustomSelect;
